export default {
  name: 'ACarouselSlide',
  props: {
    index: {
      type: Number,
      required: true
    },
    ssrNumber: {
      type: Number,
      required: false,
      default: 1
    },
    ssrMargin: {
      type: Number,
      required: false,
      default: 0
    }
  },
  render(h) {
    const carouselIsRegistered = this.$options.components['swiper'] != null
    if (carouselIsRegistered) {
      return h('swiper-slide', this.$slots.default)
    }

    let style = {
      'width': `calc(100% / ${this.ssrNumber} - ${this.ssrMargin * (this.ssrNumber - 1) / this.ssrNumber}px)`
    }
    if (this.index >= this.ssrNumber) {
      style.display = 'none'
    }

    return h('div', {
      class: 'swiper-slide',
      style
    }, this.$slots.default)
  }
}
